import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const Container = styled.div`
  color: var(--black);
  text-align: center;
  background-color: var(--white);
  height: 100%;
  width: 100%;
  padding: 130px 158px 0 158px;
  overflow: hidden;

  .document-pdf .react-pdf__Page__canvas {
    width: 100% !important;
    height: auto !important;
    margin: 20px 0;
  }

  @media only screen and (max-width: 414px) {
    padding: 130px 52px 0 52px !important;
  }

  @media only screen and (max-width: 820px) {
    padding: 130px 74px 0 74px;
  }

  .row-section {
    display: flex;
  }

  @media only screen and (max-width: 630px) {
    .row-section {
      .ant-col-8 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
    }

    .row-contanct {
      .ant-col-6 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }

      .ant-col-9 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
    }
  }

  @media only screen and (max-width: 767px) {
    .row-section {
      .ant-col-8 {
        flex: 0 0 50%;
        max-width: 50%;
      }
    }

    .row-contanct {
      .ant-col-6 {
        flex: 0 0 50%;
        max-width: 50%;
      }

      .ant-col-9 {
        flex: 0 0 50%;
        max-width: 50%;
      }
    }
  }

  @media only screen and (width: 1024px) and (orientation: portrait) {
    .row-section {
      padding-left: 30px;

      .ant-col-8 {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
    }
  }
`

export const Title = styled.h1`
  height: 100%;
  width: 100%;
  font-family: 'Noto Sans Thai';
  line-height: 150px;
  font-size: clamp(30px,9vw, 64px);
  text-align: left;

  @media only screen and (max-width: 414px) {
    line-height: 60px;
  }
`

export const TextSection = styled.p`
  color: var(--black);
  font-family: 'Noto Sans Thai';
  line-height: 35px;
  font-size: clamp(20px, 2.5vw, 24px);
  text-align: left;
  margin-bottom: 20px;

  @media only screen and (width: 1024px) and (orientation: portrait) {
    line-height: 30px;
  }

  width: fit-content;
  position: relative;
  text-decoration: none;

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 4px;
    border-radius: 4px;
    background-color: var(--secondary);
    bottom: -1px;
    left: 0;
    transform-origin: right;
    transform: scaleX(0);
    transition: transform 0.3s ease-in-out;
  }

  &:hover::before {
    transform-origin: left;
    transform: scaleX(1);
  }
`

export const Href = styled(Link)`
  color: var(--white);
  width: 100%;
  display: flex;
`

export const SubTitle = styled.p`
  font-family: 'Noto Sans Thai Bold';
  text-align: ${(props) => (props.align ? props.align : 'left')};
  font-size: clamp(22px, 2.5vw, 40px);
  line-height: 50px;
  margin-left: 30px;
  margin-top: ${(props) => props.top && `${props.top}px`} !important;

  @media only screen and (max-width: 414px) {
    margin-top: 50px !important;
    margin-left: 0 !important;
  }

  @media only screen and (min-width: 1440px) {
    margin-bottom: 50px;
  }
`

export const BoxPrint = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
  cursor: pointer;

  .icon {
    position: relative;
    background: var(--white);
    border-radius: 50%;
    padding: 15px;
    margin: 10px;
    width: 50px;
    height: 50px;
    font-size: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  }

  .tooltip {
    position: absolute;
    top: 0;
    font-size: 14px;
    background: var(--white);
    color: var(--white);
    padding: 5px 8px;
    border-radius: 5px;
    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  }

  .tooltip::before {
    position: absolute;
    content: '';
    height: 8px;
    width: 8px;
    background: var(--white);
    bottom: -3px;
    left: 50%;
    transform: translate(-50%) rotate(45deg);
    transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  }

  .icon:hover .tooltip {
    top: -45px;
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
  }

  .icon:hover span,
  .icon:hover .tooltip {
    text-shadow: 0px -1px 0px rgba(0, 0, 0, 0.1);
  }

  .print:hover,
  .print:hover .tooltip,
  .print:hover .tooltip::before {
    background: var(--secondary);
    color: var(--white);
  }
`
